/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProductAttachmentSnapshotFragmentDoc, AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddProductAssetsMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
  assets: Array<Types.AttachmentInput>;
}>;


export type AddProductAssetsMutation = { addProductAssets: { __typename: 'AddProductAssetsResult', assets: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } };

export type RemoveProductAssetMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
  assetId: Types.Scalars['Int']['input'];
}>;


export type RemoveProductAssetMutation = { removeProductAssets: { __typename: 'RemoveProductAssetsResult', ok: boolean } };


export const AddProductAssetsDocument = gql`
    mutation AddProductAssets($productId: ID!, $assets: [AttachmentInput!]!) {
  addProductAssets(productId: $productId, assets: $assets) {
    assets {
      ...ProductAttachmentSnapshot
    }
  }
}
    ${ProductAttachmentSnapshotFragmentDoc}`;
export type AddProductAssetsMutationFn = Apollo.MutationFunction<AddProductAssetsMutation, AddProductAssetsMutationVariables>;

/**
 * __useAddProductAssetsMutation__
 *
 * To run a mutation, you first call `useAddProductAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductAssetsMutation, { data, loading, error }] = useAddProductAssetsMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useAddProductAssetsMutation(baseOptions?: Apollo.MutationHookOptions<AddProductAssetsMutation, AddProductAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductAssetsMutation, AddProductAssetsMutationVariables>(AddProductAssetsDocument, options);
      }
export type AddProductAssetsMutationHookResult = ReturnType<typeof useAddProductAssetsMutation>;
export type AddProductAssetsMutationResult = Apollo.MutationResult<AddProductAssetsMutation>;
export type AddProductAssetsMutationOptions = Apollo.BaseMutationOptions<AddProductAssetsMutation, AddProductAssetsMutationVariables>;
export const RemoveProductAssetDocument = gql`
    mutation RemoveProductAsset($productId: ID!, $assetId: Int!) {
  removeProductAssets(productId: $productId, assetIds: [$assetId]) {
    ok
  }
}
    `;
export type RemoveProductAssetMutationFn = Apollo.MutationFunction<RemoveProductAssetMutation, RemoveProductAssetMutationVariables>;

/**
 * __useRemoveProductAssetMutation__
 *
 * To run a mutation, you first call `useRemoveProductAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductAssetMutation, { data, loading, error }] = useRemoveProductAssetMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useRemoveProductAssetMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductAssetMutation, RemoveProductAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductAssetMutation, RemoveProductAssetMutationVariables>(RemoveProductAssetDocument, options);
      }
export type RemoveProductAssetMutationHookResult = ReturnType<typeof useRemoveProductAssetMutation>;
export type RemoveProductAssetMutationResult = Apollo.MutationResult<RemoveProductAssetMutation>;
export type RemoveProductAssetMutationOptions = Apollo.BaseMutationOptions<RemoveProductAssetMutation, RemoveProductAssetMutationVariables>;